import Vue from "vue";
import VueRouter from "vue-router";
import { validateToken } from "./CGI";

Vue.use(VueRouter);
const routes = [
  { path: "/", redirect: "/login" },
  { path: "/login", component: () => import("./views/login"), name: "login" },
  {
    path: "/home",
    component: () => import("./views/home"),
    name: "home",
    children: [
      {
        path: "product_authorization",
        component: () => import("./views/product_authorization"),
        name: "product_authorization"
      },
      {
        path: "order_management",
        component: () => import("./views/order_management"),
        name: "order_management"
      },
      {
        path: "coupon_management",
        component: () => import("./views/coupon_management"),
        name: "coupon_management"
      },
      {
        path: "member_management",
        component: () => import("./views/member_management"),
        name: "member_management"
      }
    ],
    beforeEnter: (to, from, next) => {
      validateToken();
      next();
    }
  },
  { path: "/unauthorized", component: () => import("./views/unauthorized"), name: "unauthorized" },
  {
    path: "/unauthorized_single_page",
    component: () => import("./views/unauthorized_single_page"),
    name: "unauthorized_single_page"
  },
  {
    path: "/unauthorized_all_pages",
    component: () => import("./views/unauthorized_all_pages"),
    name: "unauthorized_all_pages"
  },
  { path: "*", component: () => import("./views/404") }
];
const router = new VueRouter({
  routes
});

export default router;
